export default "__VITE_ASSET__DLe9HrK3__"